<script lang="ts">
  import { Button, Col, Form, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from "sveltestrap";
  import { Alreadyhaveanpassword, CreateYourPassword, Done, EnterOTP, EnterYourMobileNumber, IfdontreceiveOTP, NewPassword, Rememberpassword, Resend, ResetYourPassword, RetypePassword, Send, Signin, href } from "../../../../../utils/Constant/Constant";
  import Link from "svelte-link";
</script>
<Form class="theme-form login-form">
    <h4>{ResetYourPassword}</h4>
    <FormGroup>
        <Label>{EnterYourMobileNumber}</Label>
        <Row>
            <Col xs="4" sm="3">
                <Input type="text" value="+ 91" />
            </Col>
            <Col xs="4" sm="9">
                <Input type="tel" value="000-000-0000" />
            </Col>
        </Row>
    </FormGroup>
    <FormGroup>
        <Button color="primary" class="btn-block" type="submit">{Send}</Button>
    </FormGroup>
    <FormGroup>
        <span class="reset-password-link">{IfdontreceiveOTP}  <a class="btn-link text-danger" href={href}>{Resend}</a>
        </span>
    </FormGroup>
    <FormGroup>
        <Label>{EnterOTP}</Label>
        <Row>
            <Col>
                <Input class="text-center opt-text" type="text" value="00" maxlength={2} />
            </Col>
            <Col>
                <Input class="text-center opt-text" type="text" value="00" maxlength={2} />
            </Col>
            <Col>
                <Input class="text-center opt-text" type="text" value="00" maxlength={2} />
            </Col>
        </Row>
    </FormGroup>
    <h6>{CreateYourPassword}</h6>
    <FormGroup>
        <Label>{NewPassword}</Label>
        <InputGroup>
            <InputGroupText>
                <i class="icon-lock"></i>
            </InputGroupText>
            <Input type="password" name="login[password]" required placeholder="*********" />
            <div class="show-hide"><span class="show"></span></div>
        </InputGroup>
    </FormGroup>
    <FormGroup>
        <Label>{RetypePassword}</Label>
        <InputGroup>
            <InputGroupText>
                <i class="icon-lock"></i>
            </InputGroupText>
            <Input type="password" name="login[password]" required placeholder="*********" />
        </InputGroup>
    </FormGroup>
    <FormGroup>
        <div class="checkbox">
            <Input id="checkbox1" type="checkbox" />
            <Label class="text-muted" for="checkbox1">{Rememberpassword}</Label>
        </div>
    </FormGroup>
    <FormGroup>
        <Button color="primary" class="btn-block" type="submit">{Done}</Button>
    </FormGroup>
    <p>{Alreadyhaveanpassword}
        <Link class="ms-2" href={href}>{Signin}</Link>
    </p>
</Form>